module.exports = __webpack_public_path__ + "static/media/amazon_place.2536966b.jpg";